export class UploadedFile {

  file: string;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

}
